import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import manifest from "../../buddy/loading/manifest.json";

const LoaderGallery: React.FC = () => {
    return (
        <div
            className="loader-gallery"
            style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "2rem",
                justifyContent: "center",
                padding: "1rem"
            }}
        >
            {manifest.loaders.map((loader) => (
                <div key={loader.name} className="loader-item" style={{ textAlign: "center" }}>
                    <h3>{loader.name}</h3>
                    <Player
                        autoplay
                        loop
                        src={loader.src}
                        style={{ height: "150px", width: "150px" }}
                    />
                </div>
            ))}
        </div>
    );
};

export default LoaderGallery;
